export const getListDiff =
  <T>(
    unitIsEqual: (a: T, b: T) => boolean,
    getUnitIdentifier: (unit: T) => number,
  ) =>
  (a: T[], b: T[]) => {
    const aDict: { [itemId: number]: T } = {};
    a.forEach((unit) => {
      aDict[getUnitIdentifier(unit)] = unit;
    });

    const diff: any = {};

    a.forEach((unit: T) => {
      diff[getUnitIdentifier(unit)] = true;
    });

    b.forEach((unit: T) => {
      const other = aDict[getUnitIdentifier(unit)];
      diff[getUnitIdentifier(unit)] = other ? !unitIsEqual(unit, other) : true;
    });
    return diff;
  };

export const getNestedListDiff =
  <T>(
    getUnitDiff: (a: T, b: T) => any,
    getUnitIdentifier: (unit: T) => number,
  ) =>
  (a: T[], b: T[]) => {
    const aDict: { [itemId: number]: T } = {};
    a.forEach((unit) => {
      aDict[getUnitIdentifier(unit)] = unit;
    });

    const diff: any = {};

    a.forEach((unit: T) => {
      diff[getUnitIdentifier(unit)] = true;
    });

    b.forEach((unit: T) => {
      const other = aDict[getUnitIdentifier(unit)];
      diff[getUnitIdentifier(unit)] = other ? getUnitDiff(unit, other) : true;
    });
    return diff;
  };
